import axios from 'axios';
import { ISession } from '../types/Session';

export interface ISessionService {
    fetchSessions(userEmail: string): Promise<ISession[]>;
}

class SessionService implements ISessionService {
    async fetchSessions(userEmail: string): Promise<ISession[]> {
        const sessionsResponse = await axios.get<ISession[]>(
            `/users/${userEmail}/getSessions`,
        );
        return sessionsResponse.data;
    }

    async fetchValidSessions(userEmail: string): Promise<ISession[]> {
        const sessionsResponse = await axios.get<ISession[]>(
            `/users/${userEmail}/getValidSessions`,
        );
        return sessionsResponse.data;
    }
}

const SessionServiceInstance = new SessionService();

export default SessionServiceInstance;
